<template>
  <share-frame class="past-months-graph-asset">
    <past-months-bar-graph :graph-height="graphHeight" :bar-values="barValues"></past-months-bar-graph>
    <div class="bottom-arrow">
      <div class="arrow-line"></div><img :src="require('@/assets/past-editable-month/arrow-left.svg')">
    </div>
  </share-frame>
</template>

<script>
import PastMonthsBarGraph
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/past-editable-month/components/PastMonthsBarGraph';
import ShareFrame from '@/base-components/share/ShareFrame';

export default {
  name: 'PastMonthsGraphAsset',
  components: {
    PastMonthsBarGraph,
    ShareFrame,
  },
  props: {
    barValues: {
      type: Array,
      required: true,
    },
  },
  computed: {
    graphHeight() {
      return 102;
    },
  },
};

</script>

<style lang="scss">
@import "~base-ui/src/scss/riseup-colors";

.past-months-graph-asset {
  width: 500px;
  .frame {
    padding: 50px;
    .bar-graph {
      margin-bottom: 30px;
    }
  }

  .bottom-arrow {
    .arrow-line {
      height: 2px;
      background: #9B9B9B;
      display: inline-block;
      width: calc(100% - 16px);
      position: relative;
      top: -7px;
    }
    img {
      height: 16px;
    }
  }

}
</style>
